import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "alertEmployerContact"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "alertText" }, " Para continuar es necesario que diligencies tus datos de contacto ", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "Transmision_title" }, "Datos empleador", -1)
const _hoisted_5 = { class: "tableFormEmployerContact" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "Transmision_title" }, "Datos de contacto", -1)
const _hoisted_7 = { class: "tableFormEmployerContact" }
const _hoisted_8 = { class: "sectionEmployerContact" }
const _hoisted_9 = { class: "messageEmployerContact" }
const _hoisted_10 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_PopUpTratamientoDatos = _resolveComponent("PopUpTratamientoDatos")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.existenDatosContacto)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _hoisted_4,
    _createVNode(_component_el_form, {
      ref: "formRef2",
      model: _ctx.employerData
    }, {
      default: _withCtx(() => [
        _createElementVNode("table", _hoisted_5, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createVNode(_component_el_form_item, {
                  class: "field",
                  label: "Tipo de persona"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      value: _ctx.employerData?.tipoPersona,
                      disabled: ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_el_form_item, {
                  class: "field",
                  label: "Tipo de aportante"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      value: _ctx.employerData?.tipoAportante,
                      disabled: ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createVNode(_component_el_form_item, {
                  class: "field",
                  label: "Tipo de identificación"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      value: _ctx.employerData?.tipoIdentificacion,
                      disabled: ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_el_form_item, {
                  class: "field",
                  label: "Número de identificación"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      value: _ctx.employerData?.numeroIdentificacion,
                      disabled: ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createVNode(_component_el_form_item, {
                  class: "field",
                  label: "Razón Social"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      value: _ctx.employerData?.razonSocial,
                      disabled: ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_el_form_item, {
                  class: "field",
                  label: "Naturaleza júridica"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      value: _ctx.employerData?.naturalezaJuridica,
                      disabled: ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["model"]),
    _hoisted_6,
    _createVNode(_component_el_form, {
      ref: "formRef",
      model: _ctx.empleadorContacto,
      rules: _ctx.rules
    }, {
      default: _withCtx(() => [
        _createElementVNode("table", _hoisted_7, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createVNode(_component_el_form_item, {
                  class: "field",
                  label: "Nombre",
                  prop: "nombre"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.empleadorContacto.nombre,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.empleadorContacto.nombre) = $event)),
                      disabled: _ctx.empleadorContacto.registroPilaId == ''
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_el_form_item, {
                  class: "field",
                  label: "Apellido",
                  prop: "apellido"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.empleadorContacto.apellido,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.empleadorContacto.apellido) = $event)),
                      disabled: _ctx.empleadorContacto.registroPilaId == ''
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createVNode(_component_el_form_item, {
                  class: "field",
                  label: "Correo electrónico",
                  prop: "correo"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.empleadorContacto.correo,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.empleadorContacto.correo) = $event)),
                      disabled: _ctx.empleadorContacto.registroPilaId == ''
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_el_form_item, {
                  class: "field",
                  label: "Celular",
                  prop: "celular"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.empleadorContacto.celular,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.empleadorContacto.celular) = $event)),
                      disabled: _ctx.empleadorContacto.registroPilaId == ''
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.message), 1),
          (_ctx.empleadorContacto.registroPilaId != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (_ctx.botonGuardar)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.SaveEmployerContact && _ctx.SaveEmployerContact(...args))),
                      class: "Button_BColorDegraded Button_fontButtonError"
                    }, " Guardar "))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.Redirect && _ctx.Redirect(...args))),
                      class: "Button_BColorDegraded Button_fontButtonError"
                    }, " Aceptar "))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    ((!_ctx.estadoTratamientoDatos && _ctx.estadoTratamientoDatos != undefined) || _ctx.storeTycVacio)
      ? (_openBlock(), _createBlock(_component_PopUpTratamientoDatos, {
          key: 1,
          StoreVacio: _ctx.storeTycVacio
        }, null, 8, ["StoreVacio"]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Spinner, {
          key: 2,
          type: "modern"
        }))
      : _createCommentVNode("", true)
  ], 64))
}